module.exports = __webpack_public_path__ + "static/media/Atlanta Housing Authority template.8e1b8a2a.xlsx";